import ChevronRightRoundedIcon from '@material-ui/icons/ChevronRightRounded';
import React from 'react';
import styled from 'styled-components/macro';
import { RouterLink } from '../../../navigation/routerAdapter';
import {
  focusRing,
  fontSize,
  fontWeight,
  layout,
  media,
  neutral,
  radius,
  space,
  transition,
} from '../../../theme/tokens';

export const BreadcrumbNav = styled.nav`
  background: ${neutral.surface};
  border-bottom: 1px solid ${neutral.border};
  padding: ${space[2]} ${layout.gutter};

  ${media.md`
    padding: ${space[3]} ${layout.gutterWide};
  `}
`;

export const BreadcrumbList = styled.ol`
  display: flex;
  align-items: center;
  flex-wrap: nowrap;
  gap: ${space[1]};
  margin: 0 auto;
  padding: 0;
  max-width: ${layout.contentMaxWidth};
  list-style: none;
  overflow: hidden;
  font-family: ${({ theme }) => theme.fontFamily};
  font-size: ${fontSize.sm};

  ${media.md`
    flex-wrap: wrap;
  `}
`;

export const BreadcrumbItem = styled.li`
  display: flex;
  align-items: center;
  gap: ${space[1]};
  flex: 0 1 auto;
  min-width: 0;
  /* middle crumbs give up space before the first and current ones */
  ${({ isCurrent, isFirst }) => (isCurrent || isFirst) && 'flex-shrink: 0.2;'}
`;

const crumbText = `
  display: block;
  max-width: 14ch;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const BreadcrumbLink = styled(RouterLink)`
  ${crumbText}
  min-height: ${layout.touchTarget};
  line-height: ${layout.touchTarget};
  padding: 0 ${space[1]};
  border-radius: ${radius.sm};
  font-weight: ${fontWeight.semibold};
  color: ${({ theme }) => theme.buttonPrimary};
  text-decoration: underline;
  text-decoration-color: transparent;
  text-underline-offset: 0.2em;
  transition: text-decoration-color ${transition.fast};

  &:hover {
    text-decoration-color: currentColor;
  }
  ${focusRing}

  ${media.md`
    min-height: auto;
    line-height: inherit;
    max-width: 28ch;
  `}
`;

export const CurrentCrumb = styled.span`
  ${crumbText}
  padding: 0 ${space[1]};
  font-weight: ${fontWeight.bold};
  color: ${({ theme }) => theme.headerColour};
  max-width: none;
`;

export const ExpandButton = styled.button`
  min-width: ${layout.touchTarget};
  min-height: ${layout.touchTarget};
  padding: 0 ${space[2]};
  border: none;
  border-radius: ${radius.sm};
  background: none;
  color: ${({ theme }) => theme.buttonPrimary};
  font-weight: ${fontWeight.bold};
  cursor: pointer;
  ${focusRing}
`;

export const Separator = () => (
  <ChevronRightRoundedIcon
    aria-hidden="true"
    style={{
      fontSize: fontSize.lg,
      color: neutral.borderStrong,
      flexShrink: 0,
    }}
  />
);
